// @ts-nocheck
import { useContext, useState } from 'react';
import { Card } from '@/components/ui/Card';
import { ConfigContext, ConsentStateContext } from '@/context';
import { Pagination } from '@/components/ui/Pagination';
import { ConsentHistoryItem } from './ConsentHistoryItem';

function renderHistory(consentHistory) {
  const { consentHistoryNoHistory } = useContext(ConfigContext);
  if (consentHistory && consentHistory.length > 0) {
    return consentHistory.map((item, idx) => (
      <ConsentHistoryItem key={idx} item={item} />
    ));
  }

  return <div>{consentHistoryNoHistory}</div>;
}

export function ConsentHistory() {
  const { consentHistoryEnabled, consentHistoryTitle } =
    useContext(ConfigContext);
  const { loaded, events } = useContext(ConsentStateContext);
  const pageSize = 10;
  const [page, setPage] = useState(1);

  const handleChange = (nextPage) => {
    setPage(nextPage);
  };

  const startIndex = (page - 1) * pageSize;
  const endIndex = startIndex + pageSize;

  const currentItems = events.slice(startIndex, endIndex);

  return (
    consentHistoryEnabled && (
      <Card loading={!loaded} title={consentHistoryTitle}>
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          {renderHistory(currentItems)}
        </div>
        {events.length > pageSize && (
          <div className="flex">
            <div className="flex-grow" />
            <Pagination
              current={page}
              pageSize={pageSize}
              total={events.length}
              onChange={handleChange}
            />
          </div>
        )}
      </Card>
    )
  );
}
